import { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';

import ImageGrid from 'pages/account/templates/RequestPage/styled/ImageGrid';
import Illustration from 'components/Illustration/Illustration';

import IllustrationWrapper from '../styled/IllustartionWrapper';

const LoginFormWrapper = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('ROUTING_LOGIN_TITLE')}</title>
        <meta name="description" content={t('ROUTING_LOGIN_DESCRIPTION')} />
      </Helmet>
      <Box flexGrow={1}>
        <Grid container sx={{ height: '100%' }}>
          <ImageGrid size={{ lg: 5, xl: 5 }}>
            <IllustrationWrapper disableGutters>
              <Illustration component="login" />
            </IllustrationWrapper>
          </ImageGrid>
          {children}
        </Grid>
      </Box>
    </>
  );
};

export default LoginFormWrapper;
